import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Building2, Activity, AlertCircle, TrendingUp, User } from 'lucide-react';

const STORAGE_KEY = 'unihub_welcomed_v1';

export default function WelcomeModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.localStorage.getItem(STORAGE_KEY) !== 'true') {
      setOpen(true);
    }
  }, []);

  const dismiss = () => {
    try { window.localStorage.setItem(STORAGE_KEY, 'true'); } catch { /* ignore */ }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="welcome-overlay" onClick={(e) => e.target === e.currentTarget && dismiss()}>
      <div className="welcome-modal">
        <button className="welcome-close" onClick={dismiss} aria-label="Dismiss"><X size={18} /></button>

        <div className="welcome-header">
          <h2>Welcome to UniHub</h2>
          <p>The control center for your NexKoins portfolio.</p>
        </div>

        <div className="welcome-features">
          <div className="welcome-feature">
            <Building2 size={20} />
            <div>
              <strong>Businesses</strong>
              <span>Each business has its own dashboard, sub-apps (Internal OS, Recon), and access roles.</span>
            </div>
          </div>
          <div className="welcome-feature">
            <TrendingUp size={20} />
            <div>
              <strong>Portfolio tab</strong>
              <span>Live revenue / cash / net profit rolled up across all entities linked to the Ledger.</span>
            </div>
          </div>
          <div className="welcome-feature">
            <AlertCircle size={20} />
            <div>
              <strong>Needs Attention</strong>
              <span>Surfaces pending invites, unmatched bank items, and the monthly newsletter status.</span>
            </div>
          </div>
          <div className="welcome-feature">
            <Activity size={20} />
            <div>
              <strong>Activity feed</strong>
              <span>Top-right activity icon shows recent changes across all your entities.</span>
            </div>
          </div>
          <div className="welcome-feature">
            <User size={20} />
            <div>
              <strong>Profile</strong>
              <span>Click your email in the header to change your display name or password.</span>
            </div>
          </div>
        </div>

        <div className="welcome-actions">
          <Link to="/profile" className="btn btn-ghost" onClick={dismiss}>Open Profile</Link>
          <button className="btn btn-primary" onClick={dismiss}>Got it</button>
        </div>
      </div>
    </div>
  );
}
